import { useLayoutEffect, useMemo, useState } from "react";


export default function useGetwidth() {
    const [width, setwidth] = useState(window.innerWidth);
    const [availHeight, setAvailHeight] = useState(window.innerHeight);

    function updateSize() {
        setwidth(window.innerWidth);
        setAvailHeight(window.innerHeight);
    }

    useLayoutEffect(() => {
        //updateSize() ;
        window.addEventListener('resize', updateSize)

    }, []);

    const ChartWidth = () => {
        if (width) {
            const Canvas = document.getElementsByTagName("canvas") as HTMLCollectionOf<HTMLElement>;
            Canvas[0].style.height = "100%";
            Canvas[0].style.width = "100%";
            for (let i = 0; i < Canvas.length; i++) {
                Canvas[i].style.width = "100%"
                Canvas[i].style.height = "100%";
            }
        }

    }

    return { width, availHeight, ChartWidth }
}